module.exports = __webpack_public_path__ + "media/images/slides_2_0-e9008b0db90c28317d9ff7f142694e57.png";